import { UniqueId } from '@shared/api';

export enum CorporateActionEventTypeEnum {
    BIDS = 'Tender Offer',
    BPUT = 'Mandatory Put, Partial Mandatory Put, Put',
    BRUP = 'Plan of Reorganization (Bankruptcy)',
    CAPD = 'Return of Capital',
    CAPG = 'Capital Gains Distribution',
    CAPI = 'Principal (Capitalisation)',
    CHAN = 'Name Change',
    CONS = 'Consent',
    CONV = 'Conversion',
    DETI = 'Security Separation',
    DFLT = 'Default',
    DRAW = 'Partial Call',
    DRCA = 'Return of Capital, Sale Of Rights',
    DRIP = 'Automatic Dividend Reinvestment',
    DTCH = 'Dutch Auction',
    DVCA = 'Cash Dividend',
    DVOP = 'Dividend with Option',
    DVSE = 'Stock Dividend',
    EXOF = 'Exchange Offer, Mandatory Exchange, Termination',
    EXRI = 'Rights Subscription, Sale Of Rights',
    EXWA = 'Warrants Exercise',
    INFO = 'General Information',
    INTR = 'Interest',
    LIQU = 'Liquidation',
    MCAL = 'Final Paydown, Full Call',
    MRGR = 'Merger',
    NOOF = 'Tender Offer',
    ODLT = 'Odd Lot Offer',
    OTHR = 'Distribution, Reorganization, Tax Event',
    PDEF = 'Full Prerefunding, Partial Defeasance, Partial Prerefunding',
    PINK = 'Pay in Kind',
    PLAC = 'Change',
    PRED = 'Principal',
    REDM = 'Termination, CD Early Redemption, Maturity, Redemption of Warrants',
    RHDI = 'Rights Distribution',
    SOFF = 'Spin-Off',
    SPLF = 'Stock Split',
    SPLR = 'Reverse Split',
    TEND = 'Tender Offer',
    TNDP = 'Tax Event',
    TREC = 'Tax Refund',
    WRTH = 'Worthless',
}

export interface ISettingsDTCMessagesCasDto {
    id: string;
    createdAt: string;
    updatedAt: string;
    isProcessed: boolean;
    isDividendApproved: boolean;
    instruction: Instruction;
    offclCorpActnEvtId: string;
    type: string;
    cusip: string;
    securityId: number;
    recordDate: string;
    effectiveDate: string;
}

interface Instruction {
    $type: string;
}

export interface ISettingsDTCMessagesCasPreviewDto {
    id: string;
    date: string;
    cusip: string;
    type: string;
    displayType: string;
    additionalInfo: string;
    status: string;
    errorMessage: string;
    executionDate: string;
    pageTypes: string[];
}

export interface IServiceCasNewPositionsDto {
    positionId: UniqueId;
    quantity: number;
    price: number;
}

export interface IServiceCasModifiedPositionsDto {
    id: UniqueId;
    accountId: number;
    cusip: string;
    oldQuantity: number;
    newQuantity: number;
    oldAverageOpenPrice: number;
    newAverageOpenPrice: number;
    oldAverageClosePrice: number;
    newAverageClosePrice: number;
}

export interface IServiceCasDeletedPositionsDto {
    positionId: UniqueId;
    quantity: number;
}

export interface IServiceCasDisbursementsDto {
    accountId: UniqueId;
    dps: number;
    grossPayout: number;
    shareCountOnRecordDate: number;
}

export interface IServiceCasReorganizationDto {
    securityId: UniqueId;
    oldName: string;
    newName: string;
    oldCusip: string;
    newCusip: string;
}

interface ITimestamp {
    hour: number;
    minute: number;
    second: number;
    millisecond: number;
    microsecond: number;
    nanosecond: number;
    ticks: number;
}

export interface ISettingsDTCMessagesIcmDto {
    id: string;
    createdAt: string;
    updatedAt: string;
    icmData: string;
    messageType: string;
    messageVersion: string;
    timestamp: ITimestamp;
    boxNumber: number;
    controlFileNumber: number;
    messageCount: number;
    messageLength: number;
    settlementPathId: string;
    settlementId: string;
}

export interface ISettingsDTCMessagesUtcDto {
    id: string;
    createdAt: string;
    updatedAt: string;
    fixData: string;
    orderId: string;
    symbol: string;
    msgType: string;
}

export interface ISettingsDTCMessagesOwDto {
    id: string;
    createdAt: string;
    updatedAt: string;
    swiftData: string;
    isoMessageType: number;
    status: string;
    messageId: string;
    protocolId: string;
    logicalTerminal: string;
    sessionNumber: number;
    sequenceNumber: number;
    isInputOrOutput: string;
    messagePriority: string;
    messageVersion: string;
    dateDetailsId: string;
    transactionId: string;
}
